/* global TimelineLite:false moment:false */
"use strict";

/*
 * Convert time to user's local time
 */
(function () {

	var datetime, element, elements, index;

	// set the locale based on the user's browser
	moment.locale(window.navigator.languages || window.navigator.language);

	// find time tags and update them
	elements = document.querySelectorAll("time[datetime]");
	for (index = 0; index < elements.length; index += 1) {

		element = elements.item(index);
		datetime = moment.tz(element.getAttribute("datetime"), moment.tz.guess());
		element.innerText = datetime.format("LLLL z");

	}

}());

/*
 * Animate hero and main content
 */
(function () {

	var tl = new TimelineLite();
	var heroContent = document.querySelector(".q-default-hero__content").childNodes;
	var primaryContent = document.querySelector(".description").childNodes;
	var secondaryContent = document.querySelector(".learn").childNodes;
	var divider = document.querySelector("hr");

	tl.from(divider, 0.8, {top:-163, autoAlpha: 0})
		.staggerFromTo(heroContent, 1, { y: "20%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: window.Power4.easeInOut}, 0.1, 0)
		.staggerFromTo(primaryContent, 1, { y: "20%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: window.Power4.easeInOut}, 0.1, 0.5)
		.staggerFromTo(secondaryContent, 1, { y: "20%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: window.Power4.easeInOut}, 0.1, 1);

}());
